// extracted by mini-css-extract-plugin
module.exports = {"shine-lines":"_3Ln_H8"};